import type { MeetingBasedEventTypeId } from '@ps/isp-web-services-types';
import type { TranslationTag } from '@ps/web-core-intl';

import { EventTypeId } from '@swf/sports/types/eventType';
import { isMeetingBasedEventTypeId } from '@swf/sports/utils/isEventTypeId';

import type { SectionWidgetConfig } from '../../types';
import { SportsWidgetType } from '../../widgets';
import { buildSportsLayoutPageResponse } from '../buildSportsLayoutPageResponse';

import {
  TXTWCL_Check_todayXs_odds_for_N0_N1_g_ELL,
  TXTWCL_Check_todayXs_odds_for_N0_N1_h_ELL,
  TXTWCL_N0_N1_betting_X_race_odds_
} from './sportsAnimalRacingRace.messages.json';

const descriptionMap: Record<MeetingBasedEventTypeId, TranslationTag> = {
  [EventTypeId.HORSE_RACING]: TXTWCL_Check_todayXs_odds_for_N0_N1_h_ELL,
  [EventTypeId.GREYHOUND_RACING]: TXTWCL_Check_todayXs_odds_for_N0_N1_g_ELL
};

const sportsAnimalRacingRaceWidgets = [
  {
    title: 'Sports Race Page Widget',
    _content_type_uid: SportsWidgetType.SportsRacePage
  }
] satisfies readonly SectionWidgetConfig[];

export const sportsAnimalRacingRace = ({ eventTypeId }: { eventTypeId: EventTypeId }) => {
  const descriptionTag = isMeetingBasedEventTypeId(eventTypeId)
    ? descriptionMap[eventTypeId]
    : TXTWCL_Check_todayXs_odds_for_N0_N1_h_ELL;

  return buildSportsLayoutPageResponse({
    alias: 'sportsAnimalRacingRace',
    seoConfig: {
      apiPath: '/meta/animal-race/',
      descriptionTag,
      titleTag: TXTWCL_N0_N1_betting_X_race_odds_,
      translationsMap: {
        '0': 'startTime',
        '1': 'venue'
      }
    },
    mainSectionWidgetConfigs: sportsAnimalRacingRaceWidgets
  });
};
